import { useQuery } from 'utils/react-query';
import { ARTIST_TYPE_ID } from 'constants/index';
import * as API from '../../API';
import { PROFILES_ENDPOINT } from '../../../constants/endpointConstants';
import { defaultListParams, formatResponseToList } from '../../crudUtils';
import { VALID_ENTITY_FILTER } from '../../../containers/ProductionUpdateSteps/constants';

export const searchArtistsQK = 'SEARCH_ARTISTS';
export function useArtistsSearch(query = '') {
  const queryKey = [searchArtistsQK, query];
  const params = {
    queryParams: {
      query,
      profile_type_id: ARTIST_TYPE_ID,
      validation_status: VALID_ENTITY_FILTER,
    },
  };

  return useQuery(
    queryKey,
    () => API.getList(PROFILES_ENDPOINT, { ...params, query }).then(response => formatResponseToList(response)),
    {
      initialData: defaultListParams,
      staleTime: 0,
    },
  );
}

export const searchArtistsById = 'SEARCH_ARTISTS_BY_ID';
export function useArtistsSearchById(id = []) {
  const queryKey = [searchArtistsById, id];
  const params = {
    queryParams: {
      limit: 1000,
      validation_status: VALID_ENTITY_FILTER,
    },
    filter: {
      id,
    },
  };

  return useQuery(
    queryKey,
    () => API.getList(PROFILES_ENDPOINT, params).then(response => formatResponseToList(response)),
    {
      initialData: defaultListParams,
      staleTime: 0,
    },
  );
}
